import { useCallback, useContext, useMemo } from 'react'
import MenuContext from '../MenuContext'

/**
 * Dispatching to Redux store from Menu works fine in most all devices, but
 * for E700 and A930, to avoid prop drilling, we use this context to store
 * data we need to be "responsive" to users' actions.
 * @returns {Object}
 */
const useMenu = () => {
  const useMenuContext = () => useContext(MenuContext)
  const { scrollPositions, setScrollPositions, selectedCategory, setSelectedCategory } = useMenuContext()
  const isMobile = useMemo(() => window.matchMedia('(max-width: 500px)').matches, [])

  const handleScroll = useCallback(
    (containerRef) => {
      const currentLocation = containerRef.current.scrollTop
      let currentCategoryId = ''
      if (currentLocation === 0) {
        const categoryId = Object.keys(scrollPositions)[0]
        return setSelectedCategory({ id: categoryId, search: false, highlight: true })
      }

      Object.entries(scrollPositions).forEach(([categoryId, scrollPosition]) => {
        if (currentLocation >= scrollPosition) {
          currentCategoryId = categoryId
        }
      })

      if (currentCategoryId !== selectedCategory?.id && !selectedCategory?.search) {
        setSelectedCategory({ id: currentCategoryId, search: false, highlight: true })
      }
    },
    [setSelectedCategory, scrollPositions, selectedCategory?.id, selectedCategory?.search],
  )

  return {
    scrollPositions,
    setScrollPositions,
    selectedCategory,
    setSelectedCategory,
    handleScroll,
    isMobile,
  }
}

export default useMenu
